import React, { useEffect, useState } from 'react';
import './MarketplacePracticeProfilesContainer.scss';
import { MarketplacePracticeProfile } from '../../components/MarketplaceSellerProfile/MarketplacePracticeProfile/MarketplacePracticeProfile';
import { PracticeProfileInfo } from '../../slices/profiles-data-slice/models/practice-profile-info';
import { useFormikContext } from 'formik';

interface MarketplacePracticeProfilesContainerProps {
    practices: PracticeProfileInfo[];
    profileId: string;
    setFormFieldValue(name: string, value: any): void;
    onAddLocationClicked(practiceIndex: number): void;
    removeLocation(practiceIndex: number, locationIndex: number): void;
    isEditable?: boolean;
}

export const MarketplacePracticeProfilesContainer = (
    props: MarketplacePracticeProfilesContainerProps
) => {
    const { isEditable = true } = props;
    const [selectedPracticeId, setSelectedPracticeId] = useState<string>(
        props.practices?.length ? props.practices[0]?.id : ''
    );

    const [practiceValidationErrors, setPracticeValidationErrors] = useState<
        Record<number, boolean>
    >({});

    const { errors } = useFormikContext();

    useEffect(() => {
        if (props.practices?.length && !!!selectedPracticeId) {
            setSelectedPracticeId(props.practices[0]?.id);
        }
    }, [props.practices]);

    useEffect(() => {
        if (!errors) {
            setPracticeValidationErrors({});
            return;
        }

        const practicesErrors = (errors as any).practiceProfiles as any[];
        const newErrorState: Record<number, boolean> = {};

        props.practices.forEach((_, index) => {
            newErrorState[index] = practiceHasErrors(index, practicesErrors);
        });

        setPracticeValidationErrors(newErrorState);
    }, [props.practices, errors]);

    const practiceHasErrors = (
        practiceIndex: number,
        practicesErrors: any[]
    ): boolean => {
        if (!practicesErrors) return false;

        if (Array.isArray(practicesErrors) && practicesErrors[practiceIndex]) {
            const practiceErrors = practicesErrors[practiceIndex];
            return practiceErrors && Object.keys(practiceErrors).length > 0;
        }

        return false;
    };

    const renderTabs = () => {
        return (
            <div className="body_inner_content marketplace-practice-profiles-tabs-container">
                <div className="RRT__container">
                    <div className="RRT__tabs">
                        {props.practices?.map((practice, index) => {
                            const hasErrors =
                                practiceValidationErrors[index] || false;
                            const baseClassName =
                                selectedPracticeId === practice.id
                                    ? 'RRT__tab RRT__tab--first RRT__tab--selected'
                                    : 'RRT__tab';
                            const className = hasErrors
                                ? `${baseClassName} mui-error`
                                : baseClassName;

                            return (
                                <div
                                    key={practice.id}
                                    className={className}
                                    onClick={() =>
                                        setSelectedPracticeId(practice.id)
                                    }>
                                    {practice.practiceName}
                                </div>
                            );
                        })}
                    </div>
                </div>
                {selectedPracticeId && (
                    <MarketplacePracticeProfile
                        profileId={props.profileId}
                        practice={props.practices.find(
                            (f) => f.id === selectedPracticeId
                        )}
                        fieldPrefix={`practiceProfiles[${props.practices.findIndex(
                            (p) => p.id === selectedPracticeId
                        )}]`}
                        setFormFieldValue={props.setFormFieldValue}
                        onAddLocationClicked={() =>
                            props.onAddLocationClicked(
                                props.practices.findIndex(
                                    (p) => p.id === selectedPracticeId
                                )
                            )
                        }
                        removeLocation={(locationIndex: number) =>
                            props.removeLocation(
                                props.practices.findIndex(
                                    (p) => p.id === selectedPracticeId
                                ),
                                locationIndex
                            )
                        }
                        isEditable={isEditable}
                    />
                )}
            </div>
        );
    };

    return (
        <div className="marketplace-practice-profiles-container">
            {renderTabs()}
        </div>
    );
};
